import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import {stylesheet} from 'typestyle';
import {px} from 'csx';
import {TProvider} from '../../../i18n/i18n';
import {observer} from 'mobx-react';
import {BUILDING_BLOCK_TYPES, BuildingBlockType, NamedDateRangeWithPreviewDateRange, tBuildingBlockTypeName} from '../../types/Report';
import {RedColor, WhiteColor} from '../../../styles/colors';
import {DateIdBundle} from '../../stores/ReportEditorStore';

interface BuildingBlockHeaderProps {
    idBuildingBlock: string;
    removeBuildingBlock: () => void;
    buildingBlockType: BuildingBlockType;
    additionalHeaderComponent?: React.ReactNode;
    changeBuildingBlockType: (idBuildingBlock: string, newBlockType: BuildingBlockType) => void;
    namedDateRangePackage?: {
        namedDateRanges: NamedDateRangeWithPreviewDateRange[];
        selectedIdNamedDateRange: string;
        selectedIdNamedDateCompareRange?: string;
        changeSelectedNamedDateRange: (idBuildingBlock: string, dateIdBundle: DateIdBundle) => void;
    };
}

@observer
export default class BuildingBlockHeader extends React.Component<BuildingBlockHeaderProps> {
    private onBuildingBlockTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newBlockType = e.currentTarget.value as BuildingBlockType;
        this.props.changeBuildingBlockType(this.props.idBuildingBlock, newBlockType);
    };

    private getWidthForSelectedEntry(selectedString: string): number {
        return selectedString.length * 7 + 30;
    }

    public render() {
        return (
            <div className={buildingBlockCss.buildingBlockHeader}>
                <div className={buildingBlockCss.buildingBlockHeaderTitle}>
                    <div className={buildingBlockCss.titleContainer}>
                        <TProvider>
                            {(t) => (
                                <select
                                    style={{width: this.getWidthForSelectedEntry(t(tBuildingBlockTypeName(this.props.buildingBlockType)))}}
                                    className={buildingBlockCss.titleSelect}
                                    value={this.props.buildingBlockType}
                                    onChange={this.onBuildingBlockTypeChange}>
                                    {BUILDING_BLOCK_TYPES.map((blockType) => (
                                        <option key={blockType} value={blockType}>
                                            {t(tBuildingBlockTypeName(blockType))}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </TProvider>
                    </div>
                    {this.props.additionalHeaderComponent ? this.props.additionalHeaderComponent : null}
                </div>
                <div className={buildingBlockCss.removeBuildingBlock} onClick={this.props.removeBuildingBlock}>
                    <FontAwesomeIcon icon="times" />
                </div>
            </div>
        );
    }
}
const buildingBlockCss = stylesheet({
    namedDateRangeSelect: {
        backgroundColor: 'transparent',
        marginLeft: 5,
        border: 'none',
    },
    titleContainer: {
        marginRight: 15,
    },
    titleSelect: {
        backgroundColor: 'transparent',
        fontWeight: 'bold',
        marginLeft: 5,
        border: 'none',
    },
    buildingBlockHeaderTitle: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
    },
    buildingBlockHeader: {
        display: 'flex',
        height: 30,
        textAlign: 'left',
        fontSize: 12,
    },
    removeBuildingBlock: {
        cursor: 'pointer',
        width: 30,
        height: 30,
        color: WhiteColor,
        borderRadius: 2,
        lineHeight: px(30),
        textAlign: 'center',
        backgroundColor: RedColor,
    },
});



// WEBPACK FOOTER //
// ./src/report/views/PaperSheetBlocks/BuildingBlockHeader.tsx